import styled from '@emotion/styled'
import { containers } from 'style';

const TextWrapperComponent = styled.div`
    text-align: ${props => props.align || 'left'};
    right: ${props => props.right || 'auto'};
    left: ${props => props.left || 'auto'};
    position: absolute;
    z-index: 1;
    bottom: 20%;

    &.even {
      padding-left: 5.5vw;
    }
    @media (min-width: ${containers.medium}px) {
      padding: 0 !important;
    }
`;
export default TextWrapperComponent;
